import { render, staticRenderFns } from "./CpdPoints.vue?vue&type=template&id=4e7a76a2"
import script from "./CpdPoints.vue?vue&type=script&lang=js"
export * from "./CpdPoints.vue?vue&type=script&lang=js"
import style0 from "./CpdPoints.vue?vue&type=style&index=0&id=4e7a76a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports